import { useEffect, useState } from 'react'
import { TabKey } from '../components/VehicleTrackingSystem'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Fetcher<T> = (page?: number, size?: number) => Promise<any>

export function useTabCars<T>(
  tabIn: TabKey,
  fetchers: Record<TabKey, Fetcher<T>>,
  page = 0,
  size = 10
) {
  const [cars, setCars] = useState<T[]>([])
  const [counts, setCounts] = useState<Record<TabKey, number>>({
    late: 0,
    today: 0,
    past: 0,
    tomorrow: 0, 
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        setError(null)

        const res = await fetchers[tabIn](page, size)
        const content = res.data.payload.content

        setCars(content)
        setCounts(prev => ({
          ...prev,
          [tabIn]: content.length,
        }))
      } catch {
        setError('Veriler alınamadı')
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [tabIn, page, size])

  return {
    cars,
    counts,
    loading,
    error,
  }
}
